module.exports = __webpack_public_path__ + "img/d36f8ce.png";